import { unknownDisplayName } from '@/config/constants';
import { Chat, ChatType, Maybe } from '@/graphql';

export function getGroupChatTitleFromNames(
	membersNames: string[] | undefined,
): string | undefined {
	return membersNames
		?.map((memberName) => {
			return memberName.split(' ')[0];
		})
		.join(', ');
}

type MinimalChatForTitle = Pick<Chat, 'name' | 'type'> & {
	users?: Maybe<Pick<NonNullable<Chat['users']>[0], 'displayName' | 'id'>[]>;
};

export function getChatTitleMembersRecipient(
	chat: MinimalChatForTitle | undefined | null,
	currentUserId: string,
	currentUserDisplayName?: string | null,
): {
	title: string;
	membersNames: string[];
	recipientName: string;
	recipientIds: string[];
	userIds: string[];
} {
	if (!chat) {
		return {
			title: '',
			membersNames: [],
			recipientName: '',
			recipientIds: [],
			userIds: [],
		};
	}
	const currentUserDisplayNameGuaranteed =
		currentUserDisplayName || unknownDisplayName;
	const membersNames =
		chat.users?.map((u) => u?.displayName || unknownDisplayName) || [];

	const recipientsArrayBase =
		chat.users?.filter((u) => u?.id !== currentUserId) || [];
	const recipients = recipientsArrayBase.length
		? recipientsArrayBase
		: [
				{
					id: currentUserId,
					displayName: currentUserDisplayNameGuaranteed,
				},
		  ];
	const isSelfChat =
		recipients.length === 1 && recipients[0].id === currentUserId;

	const recipientName = isSelfChat
		? `${currentUserDisplayNameGuaranteed} (you)`
		: recipients.reduce<string>((acc, user) => {
				return user?.displayName || unknownDisplayName;
		  }, unknownDisplayName) || unknownDisplayName;

	const groupChatTitle =
		chat.name || getGroupChatTitleFromNames(membersNames);

	const title =
		chat.type === ChatType.Group
			? groupChatTitle || recipientName
			: recipientName;

	return {
		title,
		membersNames,
		recipientName,
		recipientIds: recipients.map((r) => r.id),
		userIds: [...recipients.map((r) => r.id), currentUserId],
	};
}
